"use strict";

import module from "./module";
import "./sitzungsmodule.spec.js";

export default module;
